import { PROJECT_CONTENT_TAB_TYPE, ProjectContentData } from '../types';
import { tableOfContentTab } from './data';

export const autoLayer: ProjectContentData = {
  id: 'autolayer',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'blockchain-network',
          value: 'BNB',
          name: 'Blockchain Network',
          description: (
            <span>
              Indicates the blockchain
              <br />
              network for this token.
            </span>
          ),
        },
        {
          id: '$lay3r',
          value: '$LAY3R',
          name: 'Token Ticker',
          description: <span>Symbol of Token.</span>,
        },
        {
          id: 'total-supply',
          value: '30,000,000',
          name: 'Total Supply',
          description: <span>Displays the total token supply.</span>,
        },
        {
          id: 'initial-circulation-supply',
          value: (
            <>
              890,358 <span className="text-[14px]">(not including LP)</span>
            </>
          ),
          name: 'Initial Circulating Supply',
          description: (
            <span>
              Shows the circulating supply at the
              <br />
              Token Generation Event (TGE).
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: (
            <>
              500,358 <span className="text-[14px]">(not including LP)</span>
            </>
          ),
          name: 'Initial Market Cap',
          description: (
            <span>
              Reflects the initial
              <br />
              market cap at the TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$150,000',
          description: (
            <span>
              Total funds targeted to be
              <br />
              raised across all pools in this IDO.
            </span>
          ),
        },
        {
          id: 'ido-price',
          name: 'IDO Price',
          value: '$0.65',
          description: (
            <span>
              Price per token
              <br />
              during the IDO.
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              Accepted stable coin and network
              <br />
              for IDO participation.
            </span>
          ),
        },
        {
          id: 'refund-policy',
          name: 'Refund Policy',
          value: '7 Days',
          description: (
            <span>
              You can get a refund in the first 7 days
              <br />
              after the TGE if you haven't claimed any tokens yet.
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 4,
      content: [
        {
          id: 'tge',
          value: '15 %',
          name: 'At TGE',
          description: (
            <span>
              Percentage of tokens
              <br />
              claimable/distributed at the TGE.
            </span>
          ),
        },
        {
          id: 'cliff',
          value: '0 months',
          name: 'Cliff',
          description: (
            <span>
              Months until the next
              <br />
              token distribution post-TGE.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '6 months',
          name: 'Linear Vesting',
          description: (
            <span>
              Token distribution
              <br />
              schedule post-cliff period.
            </span>
          ),
        },
        {
          id: 'distribution method',
          value: 'Magic Launchpad',
          name: 'Distribution Method',
          description: (
            <span>
              Tokens can be claimed via
              <br />
              the Magic Launchpad Dashboard.
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido',
      label: 'IDO Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'sale-start',
          value: 'September 12th, 2024',
          name: 'Sale Start',
          description: <span>Start date of the IDO.</span>,
        },
        {
          id: 'sale-end',
          value: 'September 16th, 2024',
          name: 'Sale End',
          description: <span>End date of the IDO.</span>,
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: 'September 25th, 2024',
          description: (
            <span>
              Estimated date
              <br />
              of the token's TGE.
            </span>
          ),
        },
      ],
    },
  ],
};
